var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZhouxian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 230"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 229"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34630114",
    x: 0.5,
    y: 7,
    width: 6,
    height: 1,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34630115",
    x: 9.5,
    y: 7,
    width: 5,
    height: 1,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34630116",
    x: 7.5,
    y: 7,
    width: 1,
    height: 1,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34630117",
    x: 15.5,
    y: 7,
    width: 1,
    height: 1,
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZhouxian);
export default __webpack_public_path__ + "static/media/zhouxian.b279d54dd0fdb6b01873a447e96e472e.svg";
export { ForwardRef as ReactComponent };